module.exports = __webpack_public_path__ + "media/application/images/ui/filter-dropdown-active-2eac6d63c6e05abc65701efbd528ba9b.svg";